import { Award, Heart, Lightbulb, Target, Telescope } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import PageHeader from "@/components/PageHeader";

const ABOUT_IMAGE = "https://images.unsplash.com/photo-1680992046615-065f58bcb4d8?crop=entropy&cs=srgb&fm=jpg&w=1080&q=85";

export default function About() {
  const { t } = useLang();

  const values = [
    { icon: Award, title: t("about.value1"), desc: t("about.value1Desc") },
    { icon: Heart, title: t("about.value2"), desc: t("about.value2Desc") },
    { icon: Lightbulb, title: t("about.value3"), desc: t("about.value3Desc") },
  ];

  return (
    <div data-testid="about-page">
      <PageHeader title={t("about.title")} subtitle={t("about.subtitle")} testId="about-title" />

      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <h2 className="font-heading text-2xl font-bold tracking-tight text-zinc-950 md:text-3xl">{t("about.storyTitle")}</h2>
            <div className="mt-6 space-y-5 text-base leading-relaxed text-zinc-600">
              <p>{t("about.p1")}</p>
              <p>{t("about.p2")}</p>
              <p>{t("about.p3")}</p>
            </div>
          </div>
          <div className="lg:col-span-5">
            <img src={ABOUT_IMAGE} alt="Data center" className="h-72 w-full rounded-2xl object-cover lg:h-full" />
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-2">
          <div className="rounded-2xl bg-[#062B2B] p-9 text-white">
            <Target className="h-8 w-8 text-[#5EEAD4]" />
            <h3 className="mt-5 font-heading text-xl font-bold">{t("about.missionTitle")}</h3>
            <p className="mt-3 text-sm leading-relaxed text-zinc-400">{t("about.missionText")}</p>
          </div>
          <div className="rounded-2xl bg-[#0D9488] p-9 text-white">
            <Telescope className="h-8 w-8 text-blue-200" />
            <h3 className="mt-5 font-heading text-xl font-bold">{t("about.visionTitle")}</h3>
            <p className="mt-3 text-sm leading-relaxed text-blue-100">{t("about.visionText")}</p>
          </div>
        </div>

        <div className="mt-20">
          <h2 className="font-heading text-2xl font-bold tracking-tight text-zinc-950 md:text-3xl">{t("about.valuesTitle")}</h2>
          <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-3">
            {values.map((v) => (
              <div key={v.title} className="rounded-2xl border border-zinc-200 p-7">
                <v.icon className="h-7 w-7 text-[#0D9488]" />
                <h3 className="mt-4 font-heading text-lg font-bold text-zinc-950">{v.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-zinc-600">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
